import { GenerateImageTag } from '../helpers/helpers';

export default (item, html) => (
    html`
        <a class="search-result default-product" href="${item.url}" x-data="{ priceGBP: '£${ item.priceGBP }', priceEUR: '€${ item.priceEUR }' }">
            <div class="search-result__imageContainer">
                ${ GenerateImageTag(item, html) }
            </div>
            <div class="search-result__textContainer">
                <h2 class="search-result__heading">${item.title}</h2>
                ${ item.sku ? html`
                    <span class="search-result__sku">${item.sku}</span>
                ` : ''}
                ${ item.priceGBP || item.priceEUR ? html`
                    <h3 class="search-result__price" x-text="currency == 'EUR' ? priceEUR : priceGBP"></h3>
                ` : ''}
            </div>
        </a>
    `
);